import { apiInstanceWithToken } from "../integrations/ApiInstance";
import "react-toastify/dist/ReactToastify.css";
import {
  contactEndpoints
  , contactForDonationEndpoints
} from "../integrations/ApiEndpoints";

import { showErrorToast } from "../utils/Toasts";
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FILE- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 


export const sendBulkSms = async (data,) => {
  try {
    const response = await apiInstanceWithToken.post(contactEndpoints.sendBulkSmsBatch, data);
    if (response?.status === 200) {
      return response.data;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "failed..." };
  }
};

export const checkDeliveryStatusBulkSms = async (data,) => {
  try {
    const response = await apiInstanceWithToken.post(contactEndpoints.checkDeliveryStatusBulkSms, data);
    if (response?.status === 200) {
      return response.data;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "failed..." };
  }
};

export const sendBulkMobileStatusUpdate = async (data,) => {
  try {
    const response = await apiInstanceWithToken.post(contactEndpoints.sendBulkMobileStatusUpdate, data);
    if (response?.status === 200) {
      return response.data;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "failed..." };
  }
};
export const donationFollowupSmsSend = async (data,) => {
  try {
    const response = await apiInstanceWithToken.post(contactForDonationEndpoints.donationFollowupSmsSend, data);
    if (response?.status === 200) {
      return response.data;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "failed..." };
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FILE - END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 